import React from 'react'
import { useNavigate } from "react-router-dom";
import { LuCheck } from "react-icons/lu";
import { Button } from "antd";

function ApplicationStatus() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-center items-center min-h-[400px]">
      <div className="flex items-center justify-center p-4 mb-6 border-4 border-green-500 rounded-full">
        <LuCheck size={50} className="text-green-500" />
      </div>

      <h1 className="text-3xl font-semibold primary mb-3">
        Thank You For Submitting
      </h1>

      <p className="text-lg font-medium mb-3">
        Your Live Trading Account Application
      </p>

      <p className="text-gray-500 mb-6">
        We will carefully review your application and notify you once your
        account is approved.
      </p>

      <Button
        type="primary"
        size="large"
        onClick={() => navigate("/dashboard")}
        className="bg-primary themeHover"
      >
        Go to Dashboard
      </Button>
    </div>
  )
}

export default ApplicationStatus

